import { Box, Button, Link, Typography } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { mapDispatchToProps, mapStateToProps } from './ForgotPassword.container';

import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import UnauthenticatedPaths from '../UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';
import { forgotPasswordSchema } from './ForgotPassword.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

export function ForgotPassword(props) {
    const { onSendResetCode, username } = props;
    const isMounted = useRef(false);
    const [ssoEnabled, setSsoEnabled] = useState(false);

    const handleSendResetCode = useCallback(
        values =>
            onSendResetCode(values).then(result => {
                isMounted.current && setSsoEnabled(result?.ssoEnabled === true);
                return result;
            }),
        [onSendResetCode]
    );

    useEffect(() => {
        isMounted.current = true;
        return () => (isMounted.current = false);
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            {ssoEnabled ? (
                <Box display="flex" flexDirection="column" gap={3}>
                    <Typography variant="h1">
                        <Locale path="auth.forgotPassword.title" />
                    </Typography>
                    <Typography variant="body1">
                        <Locale path="auth.forgotPassword.sso.description" />
                    </Typography>
                    <Button
                        color="primary"
                        variant="contained"
                        component={RouterLink}
                        to={UnauthenticatedPaths.SIGN_IN}
                    >
                        <Locale path="auth.forgotPassword.sso.link" />
                    </Button>
                </Box>
            ) : (
                <FormikValidationForm
                    initialValues={{ username }}
                    validationSchema={forgotPasswordSchema}
                    onSubmit={handleSendResetCode}
                    title="auth.forgotPassword.title"
                    subtitle="auth.forgotPassword.description"
                    submitText="auth.forgotPassword.submitText"
                    validateOnMount
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        width="100%"
                        flexGrow={1}
                        gap={0.5}
                        alignItems="center"
                        mt={4}
                        mb={1}
                        sx={theme =>
                            theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {}
                        }
                    >
                        <FormikTextField
                            name="username"
                            label="common.email"
                            autoComplete="email"
                            fullWidth
                            required
                            mb={1}
                        />
                    </Box>
                </FormikValidationForm>
            )}
            {!ssoEnabled && (
                <Box mt={5}>
                    <Typography variant="body1">
                        <Locale path="auth.forgotPassword.haveCode.cta" />{' '}
                        <Link
                            fontWeight="bold"
                            component={RouterLink}
                            to={UnauthenticatedPaths.RESET_PASSWORD}
                        >
                            <Locale path="auth.forgotPassword.haveCode.link" />
                        </Link>
                    </Typography>
                </Box>
            )}
        </Box>
    );
}

ForgotPassword.propTypes = {
    isLoading: PropTypes.bool,
    onSendResetCode: PropTypes.func.isRequired,
    username: PropTypes.string,
};
